import { apiUploadFormData } from "@/lib/api";

export type QboAgingLedger = "ap" | "ar";

export type QboAgingMatchKind = "matched" | "qbo_only" | "supabase_only";

export interface QboAgingCsvRow {
  rowIndex: number;
  transactionDate: string | null;
  transactionType: string;
  num: string;
  counterpartyName: string | null;
  dueDate: string | null;
  pastDueDays: number | null;
  amount: number | null;
  openBalance: number | null;
  canonicalDocNumber: string | null;
  purchaseDocClass: string | null;
  isPaid: boolean;
}

export interface QboAgingMatchSummary {
  ledger: QboAgingLedger;
  asOfDate: string | null;
  reportTitle: string | null;
  qboBillOrInvoiceRows: number;
  qboGipiTshOrGosiRows: number;
  matched: number;
  qboOnly: number;
  supabaseOnly: number;
  qboOpenCount: number;
  qboPaidCount: number;
  duplicateQboCanonicalKeys: string[];
  duplicateSupabaseCanonicalKeys: string[];
}

export interface QboAgingMatchedRow {
  kind: "matched";
  canonicalDocNumber: string;
  qbo: QboAgingCsvRow;
  supabase: Record<string, unknown>;
  counterpartyNameMatches: boolean | null;
}

export interface QboAgingQboOnlyRow {
  kind: "qbo_only";
  canonicalDocNumber: string | null;
  qbo: QboAgingCsvRow;
}

export interface QboAgingSupabaseOnlyRow {
  kind: "supabase_only";
  canonicalDocNumber: string;
  supabase: Record<string, unknown>;
}

export interface QboAgingApFilterSummary {
  as_of_date: string | null;
  imported_at: string;
  filename: string;
  open_gipi_tsh_count: number;
}

export interface QboAgingArFilterSummary {
  as_of_date: string | null;
  imported_at: string;
  filename: string;
  open_gosi_count: number;
}

export interface QboAgingImportResult {
  filename: string;
  supabaseCandidateCount: number;
  ap_aging_filter: QboAgingApFilterSummary | null;
  ar_aging_filter: QboAgingArFilterSummary | null;
  summary: QboAgingMatchSummary;
  matched: QboAgingMatchedRow[];
  qboOnly: QboAgingQboOnlyRow[];
  supabaseOnly: QboAgingSupabaseOnlyRow[];
  transactionTypeCounts: Record<string, number>;
  allParsedRowCount: number;
}

export async function importQboAgingCsv(ledger: QboAgingLedger, file: File): Promise<QboAgingImportResult> {
  const formData = new FormData();
  formData.append("ledger", ledger);
  formData.append("file", file, file.name);
  return apiUploadFormData<QboAgingImportResult>(
    `/api/accounting/qbo-aging/import?ledger=${encodeURIComponent(ledger)}`,
    formData,
  );
}
